module.exports = __webpack_public_path__ + "static/media/12.6101ea52.png";